<template>
  <k-panel
    class="col-two-panel-narrow"
    title="Logins"
    icon="fa-user-unlock"
    :showContent="showContent"
    @toggle="showContent = $event"
  >
    <template #body>
      <div class="sync">
        <button class="btn btn-primary" @click="getLearnerLogins">
          Refresh <i :class="syncIcon"></i>
        </button>
      </div>
      <template v-if="learnerLoginsReady">
        <empty-placeholder v-if="learnerLogins.length === 0"
          title="No logins found for this learner"
          info="The learner currently has no active sessions on EDUKATE"
          faIcon="fas fa-address-card"
        ></empty-placeholder>
        <k-table v-else
          :rows="rows"
          :headers="columns"
          :max="10"
          :hideable="false"
          :panel="false"
          @clicked="handleTableClick"
        ></k-table>
      </template>
    </template>
  </k-panel>
</template>

<style scoped>
.sync {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 1em;
}

.sync button {
  margin-left: 1em;
}
</style>

<script>
import KPanel from '@base-components/k-panel.vue';
import KTable from '@base-components/k-table.vue';
import EmptyPlaceholder from '@base-components/empty-placeholder.vue';
import getIcon from '@utils/kate-table-icons';

export default {
  components: {
    KPanel,
    KTable,
    EmptyPlaceholder,
  },
  props: {
    learnerId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      learnerLogins: [],
      learnerLoginsReady: false,
      showContent: false,
    };
  },
  watch: {
    showContent() {
      if (this.showContent) {
        this.getLearnerLogins();
      }
    },
  },
  computed: {
    columns() {
      const cols = {
        login_time: {
          name: 'Login Time',
          type: 'timestamp',
          sortable: true,
        },
        active: {
          name: 'Active',
          sortable: true,
        },
        machine: {
          name: 'Machine',
          sortable: true,
          filterable: true,
        },
        app_name: {
          name: 'App',
          sortable: true,
          filterable: true,
        },
      };
      if (this.$permissions.hasPermission('manage_user_sessions')) {
        cols.remove = {
          name: 'Remove',
          type: 'action',
        };
      }
      return cols;
    },
    rows() {
      return this.learnerLogins.map(login => ({
        ...login,
        remove: {
          type: 'action',
          text: getIcon({ icon: 'trash' }),
        },
      }));
    },
    syncIcon() {
      return this.learnerLoginsReady ? 'fas fa-sync' : 'fas fa-spinner fa-spin';
    },
  },
  methods: {
    getLearnerLogins() {
      this.learnerLoginsReady = false;
      this.$logger.info('Getting logins for learner', { learnerId: this.learnerId });
      this.$http.get(`/api/auth/user/${this.learnerId}/logins`).then(res => {
        this.$logger.info('Successfully retrieved logins for learner', { learnerId: this.learnerId });
        this.learnerLogins = res.data;
      }).catch(err => {
        this.$logger.autowarn('Error retrieving logins for learner', { learnerId: this.learnerId }, err);
        this.$ktoast.showError(err);
      }).then(() => {
        this.learnerLoginsReady = true;
      });
    },
    removeLogin(loginId) {
      this.$logger.info('Removing login for user', { loginId, userId: this.learnerId });
      this.$Loading.minimal();
      this.$http.delete(`/api/auth/user/${this.learnerId}/logins/${loginId}`).then(() => {
        this.$logger.info('Successfully removed login', { loginId, userId: this.learnerId });
        this.$ktoast.success('Login deleted');
        this.getLearnerLogins();
      }).catch(err => {
        this.$logger.error('Error removing login', { loginId, userId: this.learnerId }, err);
        this.$ktoast.showError(err);
      }).then(() => {
        this.$Loading.finish();
      });
    },
    handleTableClick(key, index, row, header) {
      if (header === 'remove') {
        this.removeLogin(row.login_id);
      }
    },
  },
};
</script>
